import { useEffect, useRef, useState } from "react"
import { useParams } from "react-router"
import { getServerLogs } from "../api/console.js"
import { LogView } from "../components/servers/LogView.js"

const POLL_INTERVAL_MS = 5000

/** `/servers/[id]/logs` (FR seccion 19 item 7). Mismo buffer que Consola (routes/console.ts), sin input, sin permiso de escritura. */
export function ServerLogsPage() {
  const { serverId } = useParams<{ serverId: string }>()
  const [lines, setLines] = useState<string[]>([])
  const [loaded, setLoaded] = useState(false)
  const pollRef = useRef<ReturnType<typeof setInterval> | null>(null)

  useEffect(() => {
    if (!serverId) return
    let cancelled = false

    const poll = () => {
      getServerLogs(serverId)
        .then(({ lines }) => {
          if (!cancelled) {
            setLines(lines)
            setLoaded(true)
          }
        })
        .catch(() => {
          /* silencioso: se reintenta en el próximo ciclo */
        })
    }

    poll()
    pollRef.current = setInterval(poll, POLL_INTERVAL_MS)
    return () => {
      cancelled = true
      if (pollRef.current) clearInterval(pollRef.current)
    }
  }, [serverId])

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "var(--space-4)" }}>
      <div>
        <h1 style={{ fontSize: "var(--text-3xl)" }}>Logs</h1>
        <p style={{ color: "var(--text-muted)" }}>Salida reciente del servidor, actualizada cada pocos segundos.</p>
      </div>
      {!loaded ? <p style={{ color: "var(--text-muted)", fontSize: "var(--text-sm)" }}>Cargando…</p> : <LogView lines={lines} />}
    </div>
  )
}
